/**
 * Backend base URL for browser fetches.
 * Marketing API is served by the monorepo admin app at /admin/api/* (proxied on gsradio.mobi).
 */

export function normalizeApiBaseUrl(input) {
  const u = input == null ? '' : String(input).trim();
  if (!u) return null;
  if (/^https?:\/\//i.test(u)) {
    return u.replace(/\/+$/, '');
  }
  return `https://${u.replace(/^\/+/, '')}`.replace(/\/+$/, '');
}

export function getApiBaseUrl() {
  const env = process.env.REACT_APP_API_URL;
  const fromEnv = env && String(env).trim() ? normalizeApiBaseUrl(env) : null;
  if (fromEnv) return fromEnv;

  // Same-origin /admin — web rewrites /admin/* to metadata admin in production;
  // local dev uses setupProxy.js to forward /admin to localhost:3000.
  return '/admin';
}
